export enum COOKIE_BANNER_OPTIONS {
  TOP = 'top',
  BOTTOM = 'bottom',
  NONE = 'none',
}
export const ACCEPT_BUTTON_TEXT = 'Dismiss'
export const defaultUpgradeMessageProperties = {
  buttonText: ACCEPT_BUTTON_TEXT,
  location: COOKIE_BANNER_OPTIONS.TOP,
}
export const defaultUpgradeBrowserStyleClasses = {
  buttonClasses: 'buttonDefaultClass light',
}
